interface LifecycleSVGProps {
  style: React.CSSProperties;
  color: string;
}

const LifecycleSVG = ({ color, style }: LifecycleSVGProps) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="50"
    height="50"
    viewBox="0 0 50 50"
    fill="none"
  >
    <g clipPath="url(#clip0_535_18921)">
      <path
        d="M1.0415 24.9998C1.0415 11.7707 11.7707 1.0415 24.9998 1.0415C34.7498 1.0415 43.1457 6.87484 46.8748 15.229"
        stroke={color}
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M46.875 5.2085V15.6252"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M36.4585 15.625H46.8752"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.125 34.7708C6.85417 43.125 15.25 48.9583 25 48.9583C38.2292 48.9583 48.9583 38.2292 48.9583 25"
        stroke={color}
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.125 44.7917V34.375"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.5417 34.375H3.125"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.01 30.73L22.13 20H23.66L28.05 30.73H26.43L25.18 27.48H20.69L19.51 30.73H18H18.01ZM21.1 26.33H24.74L23.62 23.36C23.28 22.46 23.02 21.71 22.86 21.13C22.72 21.82 22.53 22.5 22.28 23.18L21.1 26.33Z"
        fill={color}
      />
      <path d="M29.4302 30.73V20H30.8502V30.73H29.4302Z" fill={color} />
    </g>
    <defs>
      <clipPath id="clip0_535_18921">
        <rect width="50" height="50" fill={color} />
      </clipPath>
    </defs>
  </svg>
);

export default LifecycleSVG;
